// third-party
import { combineReducers } from 'redux';

// project imports
import snackbarReducer from './slices/snackbar';
import { walletReducer } from './slices/wallet';
import { racecardReducer } from './slices/racecard';

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({ snackbar: snackbarReducer, wallet: walletReducer, raceinfo: racecardReducer });

export default reducer;
